import { IAxiosInstance } from "clients/AbstractApiClient/AbstractApiClient";

export const getContractorPaymentGroups =
  (axios: IAxiosInstance) =>
  async ({ year }: { year: string }) => {
    const response = await axios.noRetry.get("/contractor-payment-groups", {
      params: {
        year,
      },
    });
    return response.data;
  };
